export const RELATIONSHIP_INFO = {
  // RelationshipInfo elements
  CHANGE_BUTTON: 'relationship-info-change-button',
  GOTO_BUTTON: 'relationship-info-goto-button',
  TRACE_PATH_BUTTON: 'relationship-info-trace-path-button'
} as const;
